import React, { useState } from "react";
import styles from "./style.module.css";
import { TextField } from "@mui/material";
import { images } from "../../../../assets/images";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

const GetInTouch = () => {
  const { phoneIcon, emailIcon, locationIcon, CircleDesign } = images;
  const [loading, setLoading] = useState(false);
  const [formData, setFormData] = useState({
    fullName: "",
    email: "",
    phone: "",
    message: "",
  });

  const handleChange = (event) => {
    const { id, value } = event.target;
    setFormData((prevFormData) => ({
      ...prevFormData,
      [id]: value,
    }));
  };

  const handleSubmit = async (event) => {
    event.preventDefault();
    // Validation logic
    setLoading(true);
    if (!validateEmail(formData.email)) {
      toast.error("Please enter a valid email address.");
      setLoading(false);
      return;
    }

    if (formData.message.length < 20 || formData.message.length > 300) {
      toast.error("Message should be between 20 and 300 characters.");
      setLoading(false);

      return;
    }

    if (formData.fullName.length < 4 || formData.fullName.length > 20) {
      toast.error("Full name should be between 4 and 20 characters.");
      setLoading(false);
      return;
    }

    if (!validatePhone(formData.phone)) {
      toast.error("Please enter a valid phone number.");
      setLoading(false);
      return;
    }

    try {
      const response = await fetch(
        "https://job-application-mindtech.onrender.com/api/contact-form",
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify(formData),
        }
      );
      if (response.ok) {
        toast.success("Form submitted successfully");
        setFormData({
          fullName: "",
          email: "",
          phone: "",
          message: "",
        });
        // Clear form data or show a success message
      } else {
        toast.error("Form submission failed");
        setLoading(false);
        // Handle error, e.g., show an error message
      }
    } catch (error) {
      toast.error("Error submitting form:");
      setLoading(false);
      // Handle error, e.g., show an error message
    }
  };

  const validateEmail = (email) => {
    const re = /\S+@\S+\.\S+/;
    return re.test(email);
  };

  const validatePhone = (phone) => {
    const re = /^\d{10}$/;
    return re.test(phone);
  };

  return (
    <div className={styles.ContactContainer}>
      <h1>Get in Touch</h1>
      <ToastContainer style={{ zIndex: 100000 }} />

      <p className={styles.subhead}>
        We’re here for you. Feel free to reach out to us!
      </p>
      <div className={styles.formContainer}>
        <div className={styles.leftContainer}>
          <h1>Akshay Thakur</h1>
          <p className={styles.subheading}>Say something to start a chat!</p>
          <img className={styles.circleDesign} src={CircleDesign} alt="" />
          <div className={styles.contactDetails}>
            <div className={styles.allDetails}>
              <div className={styles.phone}>
                <img src={phoneIcon} alt="" />
                <p>+919422319541</p>
              </div>
              <div className={styles.phone}>
                <img src={emailIcon} alt="" />
                <p>akshay3thakur@proton.me</p>
              </div>
              <div className={styles.phone}>
                <img src={locationIcon} alt="" />
                <p className={styles.address}>
                  Vellore Institute of Technology, Kelambakkam - Vandalur Rd, Rajan Nagar, Chennai, Tamil Nadu 600127
                </p>
              </div>
            </div>
          </div>
        </div>
        <div id="getInTouch" className={styles.rightContainer}>
          <form className={styles.form}>
            <div className={styles.inputContainer}>
              <TextField
                id="fullName"
                className={styles.input}
                label="Full Name"
                variant="outlined"
                value={formData.fullName}
                onChange={handleChange}
              />
            </div>

            <div className={styles.inputContainer}>
              <TextField
                id="email"
                className={styles.input}
                label="Email ID"
                variant="outlined"
                value={formData.email}
                onChange={handleChange}
              />
            </div>

            <div className={styles.inputContainer}>
              <TextField
                id="phone"
                className={styles.input}
                label="Phone Number"
                variant="outlined"
                value={formData.phone}
                onChange={handleChange}
              />
            </div>

            <div className={styles.textareaContainer}>
              <TextField
                id="message"
                className={styles.textarea}
                label="Enter your Message"
                variant="outlined"
                multiline
                rows={4}
                value={formData.message}
                onChange={handleChange}
              />
            </div>

            <button onClick={handleSubmit} disabled={loading}>
              Get in Touch
            </button>
          </form>
        </div>
      </div>
    </div>
  );
};

export default GetInTouch;
